<template>
    <div>
        <h1 class="text-center" style="margin-top: 100px">
            Importation de données
        </h1>
    </div>
</template>

<script>
export default {
    name: 'ImportationHome',

    created() {
        this.$store.commit('reportingVM/RESET_SEARCH')
    },
}
</script>

<style scoped></style>
